import axios from "axios";
import { message } from "element-ui";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // token
    config.headers["X-Token"] = sessionStorage.getItem("token") || undefined;
    // 文件上传设置
    if (config.url == "/sfl/fileCheck") {
      config.headers["content-type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    let requestUrl = response.config.url.replace(response.config.baseURL, "");
    if (requestUrl.indexOf("?") > 0) {
      requestUrl = requestUrl.replace(
        requestUrl.substring(requestUrl.indexOf("?")),
        ""
      );
    }
    if (
      res.code !== 0 &&
      res.code !== 200 &&
      res.code !== 500 &&
      requestUrl != "/sfl/fileCheck" &&
      !requestUrl.includes("/sfl/getYzm") &&
      !requestUrl.includes("/sfl/ytCheck")
    ) {
      message.error(res.message || "Error");
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js